// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Module } from './module';
import type { ModuleLecturerResponse } from './moduleLecturerResponse';

export type GenericApiResponseUnionModuleModuleLecturerResponseData = Module | ModuleLecturerResponse | null;
